import FilterListRoundedIcon from "@mui/icons-material/FilterListRounded";
import { FormikProvider, useFormik } from "formik";
import Filter from "library/Molecules/Filter";
import Menu from "library/Molecules/Menu";
import { values } from "lodash";
import { useCallback, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { retrieveLibraryListType, setAddressListType, setOrderListType } from "store/features/library.store";
import { LIBRARY_ITEM_TYPES } from "../../../../../constants";

const LibraryFilters = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const listType = useSelector(retrieveLibraryListType);

  const typeFilterRef = useRef();

  const filtersForm = useFormik({
    initialValues: { type: listType },
    onSubmit: ({ type }) => {
      type === LIBRARY_ITEM_TYPES.addresses ? dispatch(setAddressListType()) : dispatch(setOrderListType());
    },
  });
  const {
    values: { type },
    setFieldValue,
    submitForm,
  } = filtersForm;

  const typeFilterOptions = useMemo(() => {
    return [...values(LIBRARY_ITEM_TYPES).map((value) => ({ label: t(`utils.libraryItemTypes.${value}`), value }))];
  }, [t]);

  const handleChangeType = useCallback(
    (value) => {
      type !== value &&
        setFieldValue("type", value).then(() => {
          submitForm();
          typeFilterRef?.current?.closeMenu?.();
        });
    },
    [setFieldValue, submitForm, type]
  );

  return (
    <FormikProvider value={filtersForm}>
      <Filter
        id="library-type-filter"
        ref={typeFilterRef}
        label={typeFilterOptions.find(({ value }) => value === type).label}
        icon={<FilterListRoundedIcon fontSize="small" />}
        data-value={`value-${type}`}
      >
        <>
          <Menu.MenuItem className="mx-3 mb-2 px-4" disabled>
            {t("common.forms.filterLabel")}
          </Menu.MenuItem>

          {typeFilterOptions.map(({ label, value }) => (
            <Menu.MenuItem
              key={value}
              selected={type === value}
              onClick={() => handleChangeType(value)}
              aria-selected={type === value}
              data-value={value}
            >
              <span className="text-fs-12 pl-3">{label}</span>
            </Menu.MenuItem>
          ))}
        </>
      </Filter>
    </FormikProvider>
  );
};

export default LibraryFilters;
